import React, { useEffect, useState } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import BOMTable, {
  SelectColumnFilter,
  StatusPill,
  ProductImageCell,
  ExpandCell
} from "./BOMTable"; // new

function SelectionsTableData() {
  const [Items, setItems] = useState();
  useEffect(() => {
    getAuthorization()
      .get("product/all_products/?product_type=item")
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => [console.log("err", err)]);
  }, []);
  const data = [
    {
      id: "1",
      number: "10254354545",
      itemname: "Dutch Grown",
      version: "1.2",
      stock: "1",
      subRows: [
        {
          ID: "1",
          Guide: "Flow guide 1",
          
        },
        {
          ID: "2",
          Guide: "Flow guide 2",
          
        },
        {
          ID: "3",
          Guide: "Flow guide 3",
          
        },
        {
          ID: "4",
          Guide: "Flow guide 3",
          
        },
      ],
    },
    {
      id: "2",
      number: "10254354545",
      itemname: "Cambo",
      version: "1.2",
      stock: "1",
      subRows: [
        {
          ID: "1",
          Guide: "Flow guide 1",
          
        },
        {
          ID: "2",
          Guide: "Flow guide 2",
          
        },
        {
          ID: "3",
          Guide: "Flow guide 3",
          
        },
        {
          ID: "4",
          Guide: "Flow guide 3",
          
        },
      ],
    },
    {
      id: "3",
      number: "10254354545",
      itemname: "Avon Bulbs",
      version: "1.2",
      stock: "2",
      subRows: [
        {
          ID: "1",
          Guide: "Flow guide 1",
          
        },
        {
          ID: "2",
          Guide: "Flow guide 2",
          
        },
        {
          ID: "3",
          Guide: "Flow guide 3",
          
        },
        {
          ID: "4",
          Guide: "Flow guide 3",
          
        },
      ],
    },
    {
      id: "4",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      version: "1.2",
      stock: "4",
      subRows: [
        {
          ID: "1",
          Guide: "Flow guide 1",
          
        },
        {
          ID: "2",
          Guide: "Flow guide 2",
          
        },
        {
          ID: "3",
          Guide: "Flow guide 3",
          
        },
        {
          ID: "4",
          Guide: "Flow guide 3",
          
        },
      ],
    },
    {
      id: "5",
      number: "10254354545",
      itemname: "Dutch Grown",
      version: "1.2",
      stock: "10",
      subRows: [
        {
          ID: "1",
          Guide: "Flow guide 1",
          
        },
        {
          ID: "2",
          Guide: "Flow guide 2",
          
        },
        {
          ID: "3",
          Guide: "Flow guide 3",
          
        },
        {
          ID: "4",
          Guide: "Flow guide 3",
          
        },
      ],
    },
  ];

  const columns = React.useMemo(
    () => [
      
      {
        Header: "Item Name",
        accessor: "itemname",
        Cell: ExpandCell,

      },
      {
        Header: "",
        accessor: "ID",
       
      },{
        Header: "",
        accessor: "Guide",
       
      },
      {
        Header: "Number",
        accessor: "number",
      },
      
      {
        Header: "Image",
        accessor: "img",
        // Cell: ProductImageCell,
      },
      {
        Header: "Version",
        accessor: "version",
      },
      {
        Header: "QTY in Stock",
        accessor: "stock",
        // Cell: (value) => (
        //   <div className=" flex w-1/2 mr-8 ">
        //     <input
        //       className="w-full bg-transparent p-2"
        //       type="text"
        //       // value={products.count}
        //       // value={counter}
        //       // onChange={(e) => {
        //       //   decrease(e);
        //       //   handleChange(e);
        //       // }}
        //       // onChange={handleChange}
        //     />
        //   </div>
        // ),
      },
      {
        Header: "Pick QTY",
        accessor: "pick",
        // Cell: (value) => (
        //   <div className=" flex border  w-3/4 mr-8 border-violet-800 rounded-lg">
        //     <input
        //       className="w-full rounded-lg p-2"
        //       type="text"
        //       // onChange={decrease}
        //     />
        //   </div>
        // ),
      },
      
     
    ],
    []
  );
  // const columns = React.useMemo(
  //   () => [
  //     {
  //       Header: "Item Name",
  //       accessor: "name",
  //       // Cell: StatusPill,
  //     },
  //     {
  //       Header: "Product ID",
  //       accessor: "product_id",
  //     },
  //     {
  //       Header: "Product Type",
  //       accessor: "product_type",
  //     },
  //   ],
  //   []
  // );

  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3">
          <BOMTable columns={columns} data={data == undefined ? [] : data} />
        </div>
      </main>
    </div>
  );
}

export default SelectionsTableData;
